/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_English_FallbackInputs */

const en_directory_agent_readiness_english_fallback = /** @type {(inputs: Directory_Agent_Readiness_English_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English findings shown`)
};

const zh_directory_agent_readiness_english_fallback = /** @type {(inputs: Directory_Agent_Readiness_English_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前显示英文评测内容`)
};

/**
* | output |
* | --- |
* | "English findings shown" |
*
* @param {Directory_Agent_Readiness_English_FallbackInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_english_fallback = /** @type {((inputs?: Directory_Agent_Readiness_English_FallbackInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_English_FallbackInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_english_fallback(inputs)
	return zh_directory_agent_readiness_english_fallback(inputs)
});
export { directory_agent_readiness_english_fallback as "directory.agent_readiness.english_fallback" }